import { spacing } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.section`
  max-width: 512px;
  margin: 0 auto;
  padding: 0 0 ${spacing(10)};
`

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${spacing(10)};
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${spacing(14)};
`
